import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './DashboardHome.css';

const DashboardHome = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [recentOrder, setRecentOrder] = useState(null);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      // Get stats
      const statsResponse = await axios.get(`${API_URL}/api/user/dashboard/stats`, {
        withCredentials: true
      });
      setStats(statsResponse.data);

      // Get recent order
      if (statsResponse.data.latestOrders && statsResponse.data.latestOrders.length > 0) {
        setRecentOrder(statsResponse.data.latestOrders[0]);
      }

      // Get active subscription
      const subsResponse = await axios.get(`${API_URL}/api/user/subscriptions`, {
        withCredentials: true
      });
      if (subsResponse.data.active && subsResponse.data.active.length > 0) {
        setActiveSubscription(subsResponse.data.active[0]);
      }
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="overview-page">
      {/* Top Section - Recent Activity */}
      <div className="activity-grid">
        {/* Recent Order Card */}
        <div className="activity-card">
          <div className="card-header">
            <h3>Recent Order</h3>
          </div>
          {recentOrder ? (
            <div className="card-content">
              <div className="order-summary">
                <span className="order-id">Order #{recentOrder.id.slice(0, 8).toUpperCase()}</span>
                <span className={`status-badge ${recentOrder.orderStatus || recentOrder.status}`}>
                  {(recentOrder.orderStatus || recentOrder.status || 'pending').toUpperCase()}
                </span>
              </div>
              <p className="order-date">
                Placed on {new Date(recentOrder.createdAt).toLocaleDateString('en-IN', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric'
                })}
              </p>
              <div className="order-amount">₹{recentOrder.price}</div>
              <Link to="/dashboard/orders" className="btn-card-action">
                View Details →
              </Link>
            </div>
          ) : (
            <div className="card-content empty">
              <p>No orders yet</p>
              <a href="/" className="btn-card-action">Start Shopping →</a>
            </div>
          )}
        </div>

        {/* Active Subscription Card */}
        <div className="activity-card">
          <div className="card-header">
            <h3>Active Subscription</h3>
          </div>
          {activeSubscription ? (
            <div className="card-content">
              <div className="subscription-info">
                <span className="plan-name">Monthly Microgreens Box</span>
                <span className="plan-price">₹{activeSubscription.price}/month</span>
              </div>
              {activeSubscription.nextDeliveryDate && (
                <p className="next-delivery">
                  Next delivery: {new Date(activeSubscription.nextDeliveryDate).toLocaleDateString('en-IN', {
                    day: 'numeric',
                    month: 'short'
                  })}
                </p>
              )}
              <Link to="/dashboard/subscriptions" className="btn-card-action">
                Manage Subscription →
              </Link>
            </div>
          ) : (
            <div className="card-content empty">
              <p>No active subscription</p>
              <a href="/#subscription" className="btn-card-action">View Plans →</a>
            </div>
          )}
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions-section">
        <h3>Manage Your Account</h3>
        <div className="actions-grid">
          <Link to="/dashboard/orders" className="action-tile">
            <div className="tile-icon">📦</div>
            <div className="tile-content">
              <h4>My Orders</h4>
              <p>{stats?.totalOrders || 0} orders placed</p>
            </div>
            <span className="tile-arrow">→</span>
          </Link>

          <Link to="/dashboard/addresses" className="action-tile">
            <div className="tile-icon">📍</div>
            <div className="tile-content">
              <h4>Addresses</h4>
              <p>{stats?.savedAddresses || 0} saved addresses</p>
            </div>
            <span className="tile-arrow">→</span>
          </Link>

          <Link to="/dashboard/profile" className="action-tile">
            <div className="tile-icon">⚙️</div>
            <div className="tile-content">
              <h4>Account Settings</h4>
              <p>Update your profile</p>
            </div>
            <span className="tile-arrow">→</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;